export const positivePage = (value, fallback = 1) => {
  const text = String(value == null ? '' : value)
  const number = Number(text)
  return /^[1-9]\d*$/.test(text) && Number.isSafeInteger(number) && number <= 1000000 ? number : fallback
}

export const tablePaginationInUrl = (pathname = '') => (
  /^\/app\/(setting\/|legacy-operations\/|marketing\/)/.test(pathname) ||
  /^\/app\/(sales\/(user-histories|legacy-appraisals)|finance\/invoice-archive)(\/|$)/.test(pathname) ||
  /^\/app\/warehouse-team\/(inventory\/list-page|location\/list-page)(\/|$)/.test(pathname)
)

export const paginationSearch = (search, page, pageSize) => {
  const params = new URLSearchParams(search)
  params.set('page', String(positivePage(page)))
  if (pageSize !== undefined) params.set('per_page', String(Math.min(100, positivePage(pageSize, 20))))
  return `?${params.toString()}`
}

export const scrollPaginationTop = () => {
  if (typeof window === 'undefined') return
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  document.querySelectorAll('.main-content, .main-panel').forEach((node) => { node.scrollTop = 0 })
}
